
import i18n from '~/i18n';
import { IndicatorConfiguration } from './avolta-indicators.model';
import { blueLightColor, greenColor, redColor } from '~/variables';

export enum AvoltaIndicator {
    // Values

    CH4_lel = 'CH4_lel',
    CH4 = 'CH4',
    humidity = 'humidity',
    temperature = 'temperature',

    // alarms
    CH4_concentration_level = 'CH4_concentration_level',

    CH4_battery_alarm = 'CH4_battery_alarm',
    CH4_concentration_alarm = 'CH4_concentration_alarm',
    CH4_sensor_error_alarm = 'CH4_sensor_error_alarm',
    CH4_temperature_alarm = 'CH4_temperature_alarm',

    CH4_ndir_error = 'CH4_ndir_error',
    CH4_detector_error = 'CH4_detector_error',

    // raw values
    battery = 'battery',
    run_time = 'run_time',

    gateway_count = 'gateway_count',
    message_count = 'message_count',
    rssi = 'rssi',
    rsrp = 'rsrp',
    rsrq = "rsrq",
    snr = 'snr',
    spreading_factor = 'spreading_factor',
}

export const AvoltaCH4Indicator: IndicatorConfiguration =  {
    key: AvoltaIndicator.CH4_lel,
    description: i18n.global.t('indicators.ch4_lel.description'),
    label: i18n.global.t('indicators.ch4_lel.label'),
    unit: i18n.global.t('indicators.ch4_lel.unit'),
    priority: 0,
    hide: false,
    color: redColor,
};

export const AvoltaCH4ppmIndicator: IndicatorConfiguration =  {
    key: AvoltaIndicator.CH4,
    description: i18n.global.t('indicators.ch4.description'),
    label: i18n.global.t('indicators.ch4_lel.label'),
    unit: i18n.global.t('indicators.ch4_lel.unit'),
    priority: 0,
    hide: false,
    color: blueLightColor,
};

export const AvoltaTemperatureIndicator: IndicatorConfiguration =   {
    key: AvoltaIndicator.temperature,
    description: i18n.global.t('indicators.temperature.description'),
    label: i18n.global.t('indicators.temperature.label'),
    unit: i18n.global.t('indicators.temperature.unit'),
    priority: 1,
    hide: false,
    color: greenColor,
};

export const AvoltaHumidityIndicator: IndicatorConfiguration =  {
    key: AvoltaIndicator.humidity,
    description: i18n.global.t('indicators.humidity.description'),
    label: i18n.global.t('indicators.humidity.label'),
    unit: i18n.global.t('indicators.humidity.unit'),
    priority: 2,
    hide: false,
    color: '#687EFF',
};

export const indicatorsConfiguration: IndicatorConfiguration[] = [
    AvoltaCH4Indicator,
    AvoltaCH4ppmIndicator,
    AvoltaTemperatureIndicator,
    AvoltaHumidityIndicator,
    {
        key: AvoltaIndicator.battery,
        description: i18n.global.t('indicators.battery.description'),
        label: i18n.global.t('indicators.battery.label'),
        unit: i18n.global.t('indicators.battery.unit'),
        priority: 0,
        hide: true,
    },
    {
        key: AvoltaIndicator.message_count,
        description: i18n.global.t('indicators.message_count.description'),
        label: i18n.global.t('indicators.message_count.label'),
        unit: null,
        priority: 9,
        hide: true,
    },
    {
        key: AvoltaIndicator.rssi,
        description: i18n.global.t('indicators.rssi.description'),
        label: i18n.global.t('indicators.rssi.label'),
        unit: i18n.global.t('indicators.rssi.unit'),
        priority: 6,
        hide: false,
    },
    {
        key: AvoltaIndicator.rsrp,
        description: i18n.global.t('indicators.rsrp.description'),
        label: i18n.global.t('indicators.rsrp.label'),
        unit: i18n.global.t('indicators.rsrp.unit'),
        priority: 6,
        hide: false,
    },
    {
        key: AvoltaIndicator.rsrq,
        description: i18n.global.t('indicators.rsrq.description'),
        label: i18n.global.t('indicators.rsrq.label'),
        unit: i18n.global.t('indicators.rsrq.unit'),
        priority: 6,
        hide: false,
    },
    {
        key: AvoltaIndicator.snr,
        description: i18n.global.t('indicators.snr.description'),
        label: i18n.global.t('indicators.snr.label'),
        unit: i18n.global.t('indicators.snr.unit'),
        priority: 7,
        hide: false,
    },
    {
        key: AvoltaIndicator.spreading_factor,
        description: i18n.global.t('indicators.spreading_factor.description'),
        label: i18n.global.t('indicators.spreading_factor.label'),
        unit: '',
        priority: 10,
        hide: false,
    },


    {
        key: AvoltaIndicator.CH4_concentration_level,
        description: i18n.global.t('indicators.CH4_concentration_level.description'),
        label: i18n.global.t('indicators.CH4_concentration_level.label'),
        unit: '',
        priority: 10,
        hide: true,
    },

    {
        key: AvoltaIndicator.CH4_concentration_alarm,
        description: i18n.global.t('indicators.CH4_concentration_alarm.description'),
        label: i18n.global.t('indicators.CH4_concentration_alarm.label'),
        unit: '',
        priority: 10,
        hide: true,
    },
    {
        key: AvoltaIndicator.CH4_temperature_alarm,
        description: i18n.global.t('indicators.CH4_temperature_alarm.description'),
        label: i18n.global.t('indicators.CH4_temperature_alarm.label'),
        unit: '',
        priority: 10,
        hide: true,
    },
    {
        key: AvoltaIndicator.CH4_battery_alarm,
        description: i18n.global.t('indicators.CH4_battery_alarm.description'),
        label: i18n.global.t('indicators.CH4_battery_alarm.label'),
        unit: '',
        priority: 10,
        hide: true,
    },
    {
        key: AvoltaIndicator.CH4_sensor_error_alarm,
        description: i18n.global.t('indicators.CH4_sensor_error_alarm.description'),
        label: i18n.global.t('indicators.CH4_sensor_error_alarm.label'),
        unit: '',
        priority: 10,
        hide: true,
    },

    {
        key: AvoltaIndicator.run_time,
        description: i18n.global.t('indicators.run_time.description'),
        label: i18n.global.t('indicators.run_time.label'),
        unit: '',
        priority: 10,
        hide: true,
    },


];


